﻿export const topicsFiltering = {
    topicsToggler : document.getElementById('topicFilterToggler'),
    resetTopicsMobile : document.getElementById('topicFilterReset-Mobile'),
    resetTopicsDesktop : document.getElementById('topicFilterReset-Desktop'),
    topicsContainer : document.querySelector('.resource-topic-filter__topics-container'),
    topics : document.querySelectorAll('.resource-topic-filter__check-container'),
    topicInputs : document.querySelectorAll('.resource-topic-filter__checkbox'),
    topicLabels : document.querySelectorAll('.resource-topic-filter__label'),
    init: function(){
        //On Mobile, the topics shelf is closed. This function handles that
        let mm = gsap.matchMedia();
        mm.add("(max-width: 600px)", () => {
            const tl = gsap.timeline({ paused: true });
            tl.set(this.topicsContainer, { autoAlpha: 1, transformOrigin: "top center" });
            tl.from(this.topicsContainer, { scaleY: 0, display: "none", opacity: 0, duration: 0.1 });
            tl.from(this.topics, { yPercent: -20, opacity: 0, duration: .2, stagger: 0.03 });
            tl.to(this.topicsToggler, { rotate: 0, transformOrigin: "center center", duration: 0.08 }, "<");

            this.topicsToggler.addEventListener("click", function (event) {
                event.preventDefault();
                if (tl.progress() === 0) {
                    tl.play();
                } else {
                    tl.reverse();
                }
            });

            return () => { // optional
                // custom cleanup code here (runs when it STOPS matching)
            };
        });
    },

    filterEvent: function () {
        const newTopicArray = [];
        for (const topicInput of this.topicInputs) {
            if (topicInput.checked == true) {
                newTopicArray.push(topicInput.dataset.value);
            }
        }
        return newTopicArray;
    },

    resetTopics: function (event) {
        event.preventDefault();
        for (const topicInput of this.topicInputs) {
            topicInput.checked = false;
        }
    }
}

export const countryFiltering = {
    countryToggler: document.getElementById('countryFilterToggler'),
    resetCountryMobile: document.getElementById('countryFilterReset-Mobile'),
    resetCountryDesktop: document.getElementById('countryFilterReset-Desktop'),
    countryContainer: document.querySelector('.resource-country-filter__country-container'),
    countries: document.querySelectorAll('.resource-country-filter__check-container'),
    countryInputs: document.querySelectorAll('.resource-country-filter__checkbox'),
    countryLabels: document.querySelectorAll('.resource-country-filter__label'),
    init: function () {
        //On Mobile, the country shelf is closed. This function handles that
        let mm = gsap.matchMedia();
        mm.add("(max-width: 600px)", () => {
            const tl = gsap.timeline({ paused: true });
            tl.set(this.countryContainer, { autoAlpha: 1, transformOrigin: "top center" });
            tl.from(this.countryContainer, { scaleY: 0, display: "none", opacity: 0, duration: 0.1 });
            tl.from(this.countries, { yPercent: -20, opacity: 0, duration: .2, stagger: 0.03 });
            tl.to(this.countryToggler, { rotate: 0, transformOrigin: "center center", duration: 0.08 }, "<");

            this.countryToggler.addEventListener("click", function (event) {
                event.preventDefault();
                if (tl.progress() === 0) {
                    tl.play();
                } else {
                    tl.reverse();
                }
            });

            return () => { // optional
                // custom cleanup code here (runs when it STOPS matching)
            };
        });
    },

    filterEvent: function () {
        const newCountryArray = [];
        for (const countryInput of this.countryInputs) {
            if (countryInput.checked == true) {
                newCountryArray.push(countryInput.dataset.value);
            }
        }
        return newCountryArray;

    },
    resetCountries: function (event) {
        event.preventDefault();
        for (const countryInput of this.countryInputs) {
            countryInput.checked = false;
        }
    }
}

export const formatFiltering = {
    formatToggler: document.getElementById('formatFilterToggler'),
    resetFormatMobile: document.getElementById('formatFilterReset-Mobile'),
    resetFormatDesktop: document.getElementById('formatFilterReset-Desktop'),
    formatContainer: document.querySelector('.resource-format-filter__format-container'),
    formats: document.querySelectorAll('.resource-format-filter__check-container'),
    formatInputs: document.querySelectorAll('.resource-format-filter__checkbox'),
    formatLabels: document.querySelectorAll('.resource-format-filter__label'),
    init: function () {
        //On Mobile, the format shelf is closed. This function handles that
        let mm = gsap.matchMedia();
        mm.add("(max-width: 600px)", () => {
            const tl = gsap.timeline({ paused: true });
            tl.set(this.formatContainer, { autoAlpha: 1, transformOrigin: "top center" });
            tl.from(this.formatContainer, { scaleY: 0, display: "none", opacity: 0, duration: 0.1 });
            tl.from(this.formats, { yPercent: -20, opacity: 0, duration: .2, stagger: 0.03 });
            tl.to(this.formatToggler, { rotate: 0, transformOrigin: "center center", duration: 0.08 }, "<");

            this.formatToggler.addEventListener("click", function (event) {
                event.preventDefault();
                if (tl.progress() === 0) {
                    tl.play();
                } else {
                    tl.reverse();
                }
            });

            return () => { // optional
                // custom cleanup code here (runs when it STOPS matching)
            };
        });
    },

    filterEvent: function () {
        const newFormatArray = [];
        for (const formatInput of this.formatInputs) {
            if (formatInput.checked == true) {
                newFormatArray.push(formatInput.dataset.value);
            }
        }
        return newFormatArray;
    },
    resetFormats: function (event) {
        event.preventDefault();
        for (const formatInput of this.formatInputs) {
            formatInput.checked = false;
        }
    }
}

//Types for workshops. Not generic Resource Types. 
export const workshopTypeFiltering = {
    typeToggler: document.getElementById('typeFilterToggler'),
    resetTypeMobile: document.getElementById('typeFilterReset-Mobile'),
    resetTypeDesktop: document.getElementById('typeFilterReset-Desktop'),
    typeContainer: document.querySelector('.resource-type-filter__type-container'),
    types: document.querySelectorAll('.resource-type-filter__check-container'),
    typeInputs: document.querySelectorAll('.resource-type-filter__checkbox'),
    typeLabels: document.querySelectorAll('.resource-type-filter__label'),
    init: function () {
        //On Mobile, the type shelf is closed. This function handles that
        let mm = gsap.matchMedia();
        mm.add("(max-width: 600px)", () => {
            const tl = gsap.timeline({ paused: true });
            tl.set(this.typeContainer, { autoAlpha: 1, transformOrigin: "top center" });
            tl.from(this.typeContainer, { scaleY: 0, display: "none", opacity: 0, duration: 0.1 });
            tl.from(this.types, { yPercent: -20, opacity: 0, duration: .2, stagger: 0.03 });
            tl.to(this.typeToggler, { rotate: 0, transformOrigin: "center center", duration: 0.08 }, "<");

            this.typeToggler.addEventListener("click", function (event) {
                event.preventDefault();
                if (tl.progress() === 0) {
                    tl.play();
                } else {
                    tl.reverse();
                }
            });

            return () => { // optional
                // custom cleanup code here (runs when it STOPS matching)
            };
        });
    },
    filterEvent: function () {
        const newTypeArray = [];
        for (const typeInput of this.typeInputs) {
            if (typeInput.checked == true) {
                newTypeArray.push(typeInput.dataset.value);
            }
        }
        return newTypeArray;
    },
    resetTypes: function (event) {
        event.preventDefault();
        for (const typeInput of this.typeInputs) {
            typeInput.checked = false;
        }
    }
}